import React, { Component } from "react"
import FormField from "../FormField"
import { Input } from "formik-antd"

export default class Title extends Component {
  render() {
    return (
      <FormField name={this.props.name || "title"} label="Campaign Title">
        <Input data-cy="campaign-title" size="large" placeholder="e.g. New shoe launch" />
      </FormField>
    )
  }
}
